import { useMemo } from 'react';
import { useQueries, useQuery } from '@tanstack/react-query';

import { VENDORS_ME_SUBMISSIONS_COUNTS, PROJECTS_PINNED_COUNTS } from 'constants/apis';
import { useApp } from 'providers/AppProvider';
import axios from 'helpers/axios';

export const DASHBOARD_FOLLOWED_PROJECTS_COUNT_QUERY_KEY = ['projects', 'pinned', 'counts'];

export const useDashboardOverviewMetrics = () => {
  const { apiRegions } = useApp();

  const submissionCountResults = useQueries({
    queries: (apiRegions ?? []).map(region => ({
      queryKey: ['vendors', 'me', 'submissions', 'counts', region],
      queryFn: () =>
        axios.get(VENDORS_ME_SUBMISSIONS_COUNTS, {
          params: { region },
        }),
      staleTime: 5 * 60 * 1000, // 5 minutes
    })),
  });

  const followedCountResults = useQuery(DASHBOARD_FOLLOWED_PROJECTS_COUNT_QUERY_KEY, () =>
    axios.get(PROJECTS_PINNED_COUNTS).then(res => res.data)
  );

  // Fetch counts for all regions and compute the total.
  const submissionCounts = useMemo(
    () =>
      submissionCountResults.reduce(
        (counts, result) => {
          const { data: { data } = {} } = result;

          if (data) {
            counts.wip += data.wip;
            counts.missed += data.missed;
            counts.submitted += data.submitted;
            counts.awarded += data.awarded;
            counts.contracts += data.contracts;
            return counts;
          }

          return counts;
        },
        {
          wip: 0,
          missed: 0,
          submitted: 0,
          awarded: 0,
          contracts: 0,
        }
      ),
    [submissionCountResults]
  );

  const followedCount = useMemo(
    () => followedCountResults.data?.totalPinned ?? 0,
    [followedCountResults]
  );

  return { submissionCounts, followedCount };
};
